export default {
  CONFIGURATION_SMILE_SMAIL_NAME: {
    key: 'configuration_smile_smail_name',
    label: '配置管理-微笑面单-寄件信息-【隐藏姓名】'
  },
  CONFIGURATION_SMILE_SMAIL_PHONE: {
    key: 'configuration_smile_smail_phone',
    label: '配置管理-微笑面单-寄件信息-【隐藏电话】'
  },
  CONFIGURATION_RECEIPT_SMAIL_NAME: {
    key: 'configuration_receipt_smail_name',
    label: '配置管理-微笑面单-收件信息-【隐藏姓名】'
  },
  CONFIGURATION_RECEIPT_SMAIL_PHONE: {
    key: 'configuration_receipt_smail_phone',
    label: '配置管理-微笑面单-收件信息-【隐藏电话】'
  }
}
